// extracted by mini-css-extract-plugin
module.exports = {"UserStories":"UserStories_UserStories__a0ofV"};